import { RefObject, useEffect, useRef, useState } from "react";
import { useStreamingState } from "../contexts/StreamingState";
import { StreamingState } from "../types/streamingState";

export const useUserActivityState = (
  containerRef: RefObject<HTMLDivElement>,
  delay = 2000
) => {
  const { streamingState } = useStreamingState();
  const [isActive, setIsActive] = useState(false);

  const lastIsActive = useRef(false);

  useEffect(() => {
    let timeoutHandler: NodeJS.Timeout | undefined;

    if (containerRef.current !== null) {
      const containerElement = containerRef.current;
      const activityHandler = () => {
        if (timeoutHandler !== undefined) {
          clearTimeout(timeoutHandler);
        }

        if (!lastIsActive.current) {
          setIsActive(true);
          lastIsActive.current = true;
        }

        timeoutHandler = setTimeout(() => {
          setIsActive(false);
          lastIsActive.current = false;
        }, delay);
      };

      containerElement.addEventListener("pointermove", activityHandler);
      containerElement.addEventListener("pointerdown", activityHandler);
      containerElement.addEventListener("pointerup", activityHandler);
      containerElement.addEventListener("keypress", activityHandler);

      return () => {
        containerElement.removeEventListener("pointermove", activityHandler);
        containerElement.removeEventListener("pointerdown", activityHandler);
        containerElement.removeEventListener("pointerup", activityHandler);
        containerElement.removeEventListener("keypress", activityHandler);
      };
    }

    return undefined;
  }, [containerRef, delay, setIsActive]);

  return isActive || streamingState !== StreamingState.playing;
};
